import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { getOidcConfigName } from "utils/functions";
import { withOidcSecure } from "@axa-fr/react-oidc";

function PrivateRoute({ component: Component, ...props }) {
  const SecuredComponent = useMemo(() => withOidcSecure(Component, undefined, undefined, getOidcConfigName()), [Component]);

  return <SecuredComponent {...props} />;
}

PrivateRoute.propTypes = {
  component: PropTypes.func
};

function CustomRoute({ isPublic, component: Component, ...props }) {
  return isPublic ? <Component /> : <PrivateRoute component={Component} {...props} />;
}

CustomRoute.propTypes = {
  component: PropTypes.func,
  isPublic: PropTypes.bool,
  fullWidth: PropTypes.bool
};

export default CustomRoute;
